import { useState, useEffect } from "react";
import { useAuth } from "@/context/authContext";
import { getUserProfileByAuthId } from "@/Services/users.service";
import type { User } from "@/models/user";

/**
 * Loads the signed-in user's profile (district, region, ...). Access decisions use
 * usePermissions().can(...), not the profile's role.
 */
export function useUserProfile() {
  const { user } = useAuth();
  const [userProfile, setUserProfile] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadUserProfile = async () => {
      if (!user?.id) {
        setUserProfile(null);
        setIsLoading(false);
        return;
      }

      try {
        const profile = await getUserProfileByAuthId(user.id);
        setUserProfile(profile);
      } catch (err) {
        console.error("Error loading user profile:", err);
      } finally {
        setIsLoading(false);
      }
    };

    loadUserProfile();
  }, [user?.id]);

  return {
    user,
    userProfile,
    isLoading,
  };
}
